import type { OrderListItem } from 'ClientPortal/src/pages/Orders/OrderList/OrderListPageContent.data'
import { isoDateStringToLocalFormat, ListCardInfo, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const OrderInfoCell = ({ order }: { order: OrderListItem }) => {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.orderListPage.cells' })
    const locale = useCurrentResolvedLocale()
    const valuationDate = isoDateStringToLocalFormat(order.valuation_date, false, locale)
    const orderDate = isoDateStringToLocalFormat(order.order_date, false, locale)

    return (
        <ListCardInfo
            style={{
                width: '260px',
                padding: tokens.SizingSpacing075,
                borderRadius: tokens.SizingCornerS,
                backgroundColor: tokens.ColorSurfaceInverseDefault,
                gap: tokens.SizingSpacing025,
            }}
        >
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {t('orderDate')}
                </Typography>
                <Typography variant="textS" color={orderDate ? tokens.ColorTextBold : tokens.ColorTextDisabled}>
                    {orderDate || '-'}
                </Typography>
            </Stack>
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {t('valuationDateShort')}
                </Typography>
                <Typography variant="textS" color={valuationDate ? tokens.ColorTextBold : tokens.ColorTextDisabled}>
                    {valuationDate || '-'}
                </Typography>
            </Stack>
        </ListCardInfo>
    )
}
